import _ from 'lodash';
import { getTempSettingsState } from '../../firestoreData/settings/ammendSettings';
import { vsComponentTypes } from '../../viewSettings/enums/vsComponentTypes';
import { ammendViewSettings } from './reducerHelpers/ammendViewSettings';
import { dispatchConfirmationTypes, grts, responseHandlers, responseReducers } from './reducerHelpers/dispatchProps';
import { _showAppLogs } from '../contexts/LogContext';

export const updateSettingsTypes = {
  clientData: 'clientData',
  dataCollections: 'dataCollections',
  dataLists: 'dataLists',
  eventData: 'eventData',
  global: 'global',
  viewItems: 'viewItems',
  viewItems_add: 'viewItems_add',
  views: 'views',
  views_add: 'views_add',
}

const rts = {
  handleAmmend_tempViewSettings: 'handleAmmend_tempViewSettings',
  handleClear_viewSettingsChanged: 'handleClear_viewSettingsChanged',
  handleCloseCreate: 'handleCloseCreate',
  handleCopy_settingsItem: 'handleCopy_settingsItem',
  handleCopy_view: 'handleCopy_view',
  handleCopy_viewItem: 'handleCopy_viewItem',
  handleCreate: 'handleCreate',
  handleDuplicateView: 'handleDuplicateView',
  handlePaste_settingsItem: 'handlePaste_settingsItem',
  handlePaste_update: 'handlePaste_update',
  handleReorderByPosition: 'handleReorderByPosition',
  handleRestore_Defaults: 'handleRestore_Defaults',
  handleRestore_fromGlobal: 'handleRestore_fromGlobal',
  handleSetInit: 'handleSetInit',
  handleShow_copyData: 'handleShow_copyData',
  handleShow_help: 'handleShow_help',
  handleShow_modifyPropData: 'handleShow_modifyPropData',
  handleShow_permissions: 'handleShow_permissions',
  handleShow_pushData: 'handleShow_pushData',
  handleShow_viewLinking: 'handleShow_viewLinking',
  handleShowCopy_viewSettings: 'handleShowCopy_viewSettings',
  handleSortItems: 'handleSortItems',
  handleSortOk: 'handleSortOk',
  handleTestItem: 'handleTestItem',
  handleUpdate_dataCollections: 'handleUpdate_dataCollections',
  // handleUpdateFromAdd: 'handleUpdateFromAdd',
  handleUpdate_viewPage: 'handleUpdate_viewPage',
  handleViewSettingsUpdate: 'handleViewSettingsUpdate',
  setDataRoot: 'setDataRoot',
  upd: 'upd',
  updateSort: 'updateSort',
  ...grts
}

export const viewSettingsReducer = (state, action) => {

  const {
    isGlobal,
    isGlobalPageItem,
    helpKey,
    settingsParentContext,
    showPermissions,
    showCopyData,
    showModifyPropData,
    showPushData,
    showCopyViewSettings,
    showDuplicateView,
    showViewLinking,
    // mainFunctions,
    // fn_cls,
  } = state

  const { states, handlers, fns, settings } = settingsParentContext ?? {}
  const { currentSettings_state, global_state, settingsArea_state, appUser_state, paps_state, page_state, appSettings_state, framework_state } = states ?? {}
  const { appSettings_fns } = fns ?? {}
  const { firestore_handlers } = handlers ?? {}

  const { homeSettings: homeSettings_global, eventSettings } = settings ?? {}
  const { logging } = homeSettings_global ?? {}

  const { aps_global, aps_viewItems, aps_views } = _.get(currentSettings_state, 'gvviSettings', {});
  const { aps_page } = _.get(page_state, 'pageSettings', {});
  const { viewItems: viewItems_page } = aps_page ?? {}

  const { appUser } = appUser_state ?? {}
  const { settingsPreviewOn } = appSettings_state ?? {}

  const { settingsOriginType } = settingsArea_state ?? {}
  const { settings_globalPageItems } = global_state ?? {}

  const { desktopMode } = framework_state ?? {}

  let {
    settings_temp_global,
    settings_temp,
    selectedGroupItem,
  } = state

  const _settings_temp = _.cloneDeep(settings_temp)
  const _settings_temp_global = _.cloneDeep(settings_temp_global)

  const { gvvi, page } = _settings_temp ?? {}
  const { global } = gvvi ?? {}

  const { key: selectedKey } = selectedGroupItem ?? {}

  let { _global, _viewItems, _views } = getTempSettingsState(_settings_temp, isGlobal)

  const {
    dataRoot,
    dispatch,
    formData,
    isSolo,
    newViews,
    propSections,
    sortedItems,
    sortedPropItems,
    sortedPropSections,
    settings_temp: settings_temp_action, //as
    svsGv,
    swipedItem,
    type,
    updateProps,
    viType,
    view_dup,
    copyValue,
  } = action

  const { handlePaste_update } = viewSettingsHandlers(dispatch, state)

  const { name } = copyValue ?? {}

  const { sortedGroups, sortedDataItems, menuType } = action

  switch (type) {

    case rts.handleSetInit:
      return { ...state, settings_temp: _.cloneDeep(action.settings_init) }

    case rts.handleTestItem:
      return { ...state, testItem: true }

    case rts.handleClear_viewSettingsChanged:
      return { ...state, viewSettingsHaveChanged: false }

    case rts.handleRestore_fromGlobal:
      const { view: key_view } = state
      const _aps_viewItems = _.cloneDeep(aps_viewItems)
      try {
        page.viewItems[key_view].propSections = _aps_viewItems[key_view].propSections
        page.viewItems[key_view].props = _aps_viewItems[key_view].props
      } catch (error) {

      }
      return {
        ...state,
        settings_temp: _settings_temp,
        settings_preview: _settings_temp,
        settings_temp_global: _settings_temp,
        viewSettingsHaveChanged: true,
      }

    case rts.handleRestore_Defaults:
      return {
        ...state,
        viewSettingsHaveChanged: true,
      }

    case rts.handleReorderByPosition:
      const _page = reorderPageViewItems(page)
      _settings_temp.page = _page
      return {
        ...state,
        settings_temp: _settings_temp,
        viewSettingsHaveChanged: true,
      }

    // IMPORTANT: Settings - Update ViewSettings
    // this updates the temp settings
    case rts.handleAmmend_tempViewSettings:

      const ammendVsProps = {
        desktopMode,
        formData,
        isGlobal,
        isGlobalPageItem,
        logging,
        menuType,
        newViews,
        propSections,
        settings_globalPageItems,
        settings_temp_action,
        settings_temp: _settings_temp,
        settingsOriginType,
        settingsPreviewOn,
        sortedGroups,
        sortedDataItems,
        sortedItems,
        sortedPropItems,
        sortedPropSections,
        svsGv,
        updateProps,
      }

      const { settings_temp_update, _global, _viewItems } = ammendViewSettings(ammendVsProps)

      const _su = _.cloneDeep(settings_temp_update)

      if (isGlobal) {
        _su.gvvi.global = _global
        _su.gvvi.viewItems = _viewItems
      } else {
        _su.page = {
          ..._global,
          viewItems: _viewItems
        }
        // _su.page.viewItems = _viewItems
      }

      const appSettingsChanges = checkAppChanges(_settings_temp, _su)

      _showAppLogs.viewSettings && console.log('♻️⚙️settings_temp_update', _su)

      return {
        ...state,
        settings_temp: isGlobalPageItem ? _settings_temp : _su,
        settings_temp_global: isGlobalPageItem ? _settings_temp_global : _su,
        settings_preview: _su,
        settings_preview_changed: !state.settings_preview_changed,
        newViews,
        viewSettingsHaveChanged: true, // allows the save icon on the top right to enable
        appSettingsChanges,
        settingsStatus: state.settingsStatus >= 100 ? 0 : state.settingsStatus + 1,
        isGlobalPageItem,
        currentFormData: formData
      }

    case rts.handleSortItems:
      return { ...state }

    // case rts.handleUpdateFromAdd:
    //   return { ...state }

    case rts.setDataRoot:
      return { ...state, dataRoot }

    case rts.handleShowCopy_viewSettings:
      return { ...state, showCopyViewSettings: !showCopyViewSettings }

    case rts.handleDuplicateView:
      return { ...state, showDuplicateView: !showDuplicateView }

    case rts.handleShow_copyData:
      return { ...state, showCopyData: !showCopyData }

    case rts.handleShow_pushData:
      return { ...state, showPushData: !showPushData }

    case rts.handleCopy_view:
      if (name && viewItems_page && viewItems_page[name]) {
        aps_viewItems[viType] = viewItems_page[name]
        aps_viewItems[viType].key = viType
        aps_viewItems[viType].display = { caption: _.startCase(viType) }
        return {
          ...state,
          settings_temp: {
            settings_global: aps_global,
            settings_viewItems: aps_viewItems
          },
          viewSettingsHaveChanged: true
        }
      }
      return { ...state }

    case rts.handleCopy_viewItem:
      const pageView = aps_views && aps_views[view_dup] ? { ...aps_views[view_dup] } : null
      if (name && pageView && pageView.viewItems && pageView.viewItems[name]) {
        const pageViewItems = aps_views[view_dup].viewItems
        const viewItemToCopy = { ...pageView.viewItems[name] }
        pageViewItems[viType] = viewItemToCopy
        pageViewItems[viType].key = viType
        pageViewItems[viType].display.caption = _.startCase(viType)
        return {
          ...state,
          settings_temp: {
            settings_global: aps_global,
            settings_viewItems: pageViewItems
          },
          viewSettingsHaveChanged: true,
        }
      }
      return { ...state }

    case rts.handleUpdate_viewPage:
      return { ...state }

    case rts.handleUpdate_dataCollections:
      return { ...state, dataCollections: action.dataCollections, staticViews: action.staticViews }

    case rts.handleCopy_settingsItem:
      if (isGlobal) {
        if (global[selectedKey]) {
          const csk = {
            copiedSettingsItem: {
              [selectedKey]: global[selectedKey]
            }
          }
          navigator.clipboard.writeText(JSON.stringify(csk))
        }
      }
      return { ...state }

    case rts.handlePaste_settingsItem:
      if (isGlobal) {
        if (global) {
          navigator.clipboard.readText().then(item => {
            try {
              const _item = item ? JSON.parse(item) : {}
              const { copiedSettingsItem } = _item ?? {}
              if (copiedSettingsItem[selectedKey]) {
                const newValue = copiedSettingsItem[selectedKey]
                global[selectedKey] = newValue
                handlePaste_update(settings_temp)
              }
            } catch (error) {
              console.log('error', error)
            }
          })
        }
      }
      return { ...state }

    case rts.handlePaste_update:
      return { ...state, settings_temp: action.settings_pasted, viewSettingsHaveChanged: true }

    case rts.handleShow_permissions:
      return { ...state, showPermissions: showPermissions === action.a ? null : action.a }

    case rts.handleShow_modifyPropData:
      return { ...state, showModifyPropData: showModifyPropData === action.a ? null : action.a }

    case rts.handleShow_help:
      return { ...state, helpKey: helpKey === action.viType ? null : action.viType }

    case rts.handleShow_viewLinking:
      return { ...state, showViewLinking: !showViewLinking, }

    case rts.handleCreate:
      return { ...state, createMode: !state.createMode }

    case rts.handleCloseCreate:
      return { ...state, createMode: false }

    case rts.handleSortOk:
      return { ...state, settings_temp: settings_temp, createMode: false }

    case rts.favsUpdated:
      return {
        ...state,
      }

    case rts.updateSort:

      if (swipedItem) {

        const { handleSortOk, handlePropSortOk, handlePropSectionSortOk } = viewSettingsHandlers(dispatch, state)

        switch (swipedItem.key) {
          case vsComponentTypes.viewItems:
            handleSortOk(sortedItems)
            break;
          case vsComponentTypes.props:
            if (updateProps && updateProps.vit) {
              handlePropSortOk(updateProps.vit, sortedItems, propSections)
            }
            break;
          case vsComponentTypes.propSections:
            if (updateProps && updateProps.vit) {
              handlePropSectionSortOk(updateProps.vit, sortedItems)
            }
            break;
          default:
          // nothing
        }
      }

      return { ...state }


    case rts.handleCloseConfirmation:
    case rts.handleFunctionResponse:
    case rts.handleStartUpdate:
    case rts.handleStopUpdate:
    case rts.updateError:
    case rts.updateSuccess:
    case rts.updateSuccessAlt:
      return responseReducers(state, action, { updating: false, dispatch, dispatchConfirmationType: dispatchConfirmationTypes.closeAfterConfirmation, isSolo, viewSettingsHaveChanged: false })

    default:
      alert('no viewSettingsReducerTypes defined: ' + type)
      return state
  }
}

const getVis = (settings_temp) => {
  if (settings_temp) {
    const { viewItems } = settings_temp ?? {}
    return viewItems
  }
}

export const viewSettingsHandlers = (dispatch) => {

  // const { isGlobal, componentContexts } = state ?? {}

  // componentContexts
  // const { globalContext } = componentContexts ?? {}

  // pageContext
  // const { settings_globalPageItems } = globalContext ?? {}
  // const settings_temp_global = settings_globalPageItems ? _.cloneDeep(settings_globalPageItems) : null

  // const { settings_temp } = state ?? {}

  // const { _global } = getTempSettingsState(settings_temp, isGlobal)

  return {
    // handlers for handleAmmend_tempViewSettings
    handleSetInit: (settings_init) => { dispatch({ type: rts.handleSetInit, dispatch, settings_init }) },
    handleTestItem: () => { dispatch({ type: rts.handleTestItem, dispatch }) },
    handleClear_viewSettingsChanged: () => { dispatch({ type: rts.handleClear_viewSettingsChanged, dispatch }) },

    handleGroupSort: (updateProps, sortedGroups, menuType) => { dispatch({ type: rts.handleAmmend_tempViewSettings, dispatch, updateProps, sortedGroups, menuType }) },
    handleGroupItemsSort: (updateProps, sortedDataItems, menuType) => { dispatch({ type: rts.handleAmmend_tempViewSettings, dispatch, updateProps, sortedDataItems, menuType }) },
    handlePropSectionSortOk: (sortVit, sortedPropSections) => { dispatch({ type: rts.handleAmmend_tempViewSettings, dispatch, sortVit, sortedPropSections }) },
    handlePropSortOk: (sortVit, sortedPropItems, propSections) => { dispatch({ type: rts.handleAmmend_tempViewSettings, dispatch, sortVit, sortedPropItems, propSections }) },
    handleFormDataChange_settings: (formData, updateProps) => { dispatch({ type: rts.handleAmmend_tempViewSettings, dispatch, updateProps, formData }) },
    handleSortOk: (sortedItems) => { dispatch({ type: rts.handleAmmend_tempViewSettings, dispatch, sortedItems }) },
    updateViewSettingsTemp: (settings_temp, svsGv, viType, newViews) => { dispatch({ type: rts.handleAmmend_tempViewSettings, settings_temp, svsGv, viType, newViews }) },

    // other
    handleCloseCreate: () => { dispatch({ type: rts.handleCloseCreate, dispatch }) },
    handleRestore_fromGlobal: (updateProps) => { dispatch({ type: rts.handleRestore_fromGlobal, dispatch, updateProps }) },
    handleRestore_Defaults: (resetKey) => { dispatch({ type: rts.handleRestore_Defaults, dispatch, resetKey }) },
    handleReorderByPosition: (resetKey) => { dispatch({ type: rts.handleReorderByPosition, dispatch, resetKey }) },

    handleCopy_view: (viType, view_dup, copyValue) => { dispatch({ type: rts.handleCopy_view, dispatch, viType, view_dup, copyValue }) },
    handleCopy_viewItem: (viType, view_dup, copyValue) => { dispatch({ type: rts.handleCopy_viewItem, dispatch, viType, view_dup, copyValue }) },
    handleCreate: () => { dispatch({ type: rts.handleCreate, dispatch }) },
    handleOkCreate: () => { dispatch({ type: rts.handleCloseCreate, dispatch }) },
    handleSaveAs: () => { alert('save as') },
    handleShow_copyData: () => { dispatch({ type: rts.handleShow_copyData, dispatch }) },
    handleShowCopy_viewSettings: () => { dispatch({ type: rts.handleShowCopy_viewSettings, dispatch }) },
    handleDuplicateView: () => { dispatch({ type: rts.handleDuplicateView, dispatch }) },
    handleShow_pushData: () => { dispatch({ type: rts.handleShow_pushData, dispatch }) },
    handleShow_viewLinking: (currentVit) => { dispatch({ type: rts.handleShow_viewLinking, dispatch, currentVit }) },
    handleUpdate_dataCollections: (value, staticViews) => { dispatch({ type: rts.handleUpdate_dataCollections, dispatch, dataCollections: value, staticViews }) },
    // handleUpdateFromAdd: (modifyData) => { dispatch({ type: rts.handleUpdateFromAdd, modifyData, dispatch }) },
    // handleUpdateNewProps: (viewItem, newItemProps) => { dispatch({ type: rts.handleUpdateNewProps, dispatch, viewItem, newItemProps }) },
    handleUpdate_viewPage: (viewItem) => { dispatch({ type: rts.handleUpdate_viewPage, dispatch, viewItem }) },
    // handleUpdate_settings: (updateType, updateJson, setButtonConfirmation) => { dispatch({ type: rts.handleUpdate_settings, updateType, updateJson, setButtonConfirmation, dispatch }) },
    setDataRoot: (dataRoot) => { dispatch({ type: rts.setDataRoot, dispatch, dataRoot }) },
    updateSort: (swipedItem, updateProps) => { dispatch({ type: rts.updateSort, dispatch, swipedItem, updateProps }) },

    handleSortItems: (swipedItem, updateProps) => { dispatch({ type: rts.handleSortItems, dispatch, swipedItem, updateProps }) },

    handleCopy_settingsItem: () => { dispatch({ type: rts.handleCopy_settingsItem, dispatch }) },
    handlePaste_settingsItem: () => { dispatch({ type: rts.handlePaste_settingsItem, dispatch }) },
    handlePaste_update: (settings_pasted) => { dispatch({ type: rts.handlePaste_update, dispatch, settings_pasted }) },
    handleShow_permissions: (a) => { dispatch({ type: rts.handleShow_permissions, dispatch, a }) },
    handleShow_modifyPropData: (a) => { dispatch({ type: rts.handleShow_modifyPropData, dispatch, a }) },
    handleShow_help: (viType) => { dispatch({ type: rts.handleShow_help, dispatch, viType }) },

    // handle_getSettingsValue: (updateProps, isGlobalPageItem, currentViewItems) => { dispatch({ type: rts.handle_getSettingsValue, dispatch, updateProps, isGlobalPageItem, currentViewItems }) },

    ...responseHandlers(dispatch),

  }
}

export const viewSettingsInitialState = (props) => {

  const {
    isGlobal,
    isGlobalPageItem,
    settingsParentContext,
    selectedGroupItem,
    startSwipeItems,
    settings_init,
    view,
    // fn_cls,
  } = props

  const initState = {
    createMode: null,
    currentVit: null,
    helpKey: null,
    isGlobal,
    isGlobalPageItem: selectedGroupItem && selectedGroupItem.key === vsComponentTypes.globalPageItems ? true : false,
    rawData: null,
    selectedGroupItem,
    settings_temp: _.cloneDeep(settings_init),
    settingsParentContext,
    settingsStatus: 0,
    showViewLinking: false,
    startSwipeItems,
    view,
    viewSettingsHaveChanged: false,
  }

  return initState
};


const checkAppChanges = (settingsCurrent, settingsUpdated) => {

  const { gvvi: gvvi_current } = settingsCurrent ?? {}
  const { global: global_current } = gvvi_current ?? {}
  const { appStatus: appStatus_current, manifest: manifest_current, scheduledNotifications: scheduledNotifications_current } = global_current ? global_current : {}

  const { gvvi: gvvi_new } = settingsUpdated ?? {}
  const { global: global_new } = gvvi_new ?? {}
  const { appStatus: appStatus_new, manifest: manifest_new, scheduledNotifications: scheduledNotifications_new } = global_new ?? {}

  return {
    statusChanged: appStatus_current !== appStatus_new,
    notificationsChanged: scheduledNotifications_current !== scheduledNotifications_new,
    manifestChanged: manifest_current !== manifest_new,
  }
}

const reorderPageViewItems = (page) => {
  const updatedViewItems = {}
  const { viewItems } = page
  const _viewItemsShow = _.groupBy(viewItems, 'show')
  const { true: visTrue, false: visFalse } = _viewItemsShow
  const _viewItemsTrue = _.sortBy(visTrue, 'position')
  const _viewItemsFalse = _.sortBy(visFalse, 'position')
  let lastIndex = 0
  _.forEach(_viewItemsTrue, (vit, index) => {
    vit.position = index
    lastIndex = index
  })
  _.forEach(_viewItemsFalse, (vit, index) => {
    vit.position = index + lastIndex + 1
  })
  _.forEach(_viewItemsTrue, (vit) => {
    updatedViewItems[vit.key] = vit
  })
  _.forEach(_viewItemsFalse, (vit) => {
    updatedViewItems[vit.key] = vit
  })
  page.viewItems = updatedViewItems
  return page
}